
<section class="hero-bg text-center pb-24" [style.backgroundImage]="'url(' + bgImage() + ')'">
 <div class="hero-content pt-15">
 <div class="hero-badge text-white rounded-lg">
  <span class="badge-text">
    <span class="text-(--color-main)">{{badge()}}</span>
  </span>
</div>

 <div class="hero-title pt-5 ">
    <h1 class="text-white"> {{title()}}
      <br>
      <span class="text-(--color-main)">{{highlight()}}</span>
    </h1>

    <p class="hero-description text-white py-5">
    {{ descriptionLine1() }} <br />
  <span class="block">{{ descriptionLine2() }}</span>
  </p>
  </div>
 </div>






</section>
